import { FREIGHT_TABLE_STATUS_FILTER } from "../constants/freightTableStatus";
import { FREIGHT_VALIDITY_STATUS_FILTER } from "../constants/freightValidityStatus";

export default function createState() {
  return {
    items: [],
    pagination: {
      current: 1,
      perPage: 10,
      total: 0,
      lastPage: 1,
    },
    filters: {
      search: "",
      sort: null,
      tableStatus: FREIGHT_TABLE_STATUS_FILTER.ALL,
      effectivePeriodStatus: FREIGHT_VALIDITY_STATUS_FILTER.ALL,
      isDraft: null,
      fornecedor: [],
      dtInicio: null,
      dtFim: null,
    },
    counts: {
      todos: 0,
      ativas: 0,
      inativas: 0,
      rascunho: 0,
    },
    loading: false,
    error: null,
    rawById: {},
    details: null,
    detailsLoading: false,
    carriers: [],
    carriersPagination: {
      current: 1,
      perPage: 10,
      total: 0,
      lastPage: 1,
    },
    carriersFilters: {
      search: "",
      sort: null,
      status: null,
    },
    carriersLoading: false,
    routes: [],
    routesLoading: false,
    routesFilters: {
      search: "",
      sort: null,
      status: null,
    },
    options: null,
    optionsLoading: false,
    itineraryOptions: [],
    itineraryOptionsLoading: false,
  };
}
